import { el } from "@/functions/el";
import { DbChangeMessage } from "@/prayersdb";
import { prayersdb } from "@/prayersdb/prayersdb";

export async function registerPeopleDataList(): Promise<Disposable> {
  await checkForList();
  document.addEventListener("spa.navigate", checkForList);
  document.addEventListener("db.change", updateList);

  return {
    [Symbol.dispose]: () => {
      document.removeEventListener("spa.navigate", checkForList);
      document.removeEventListener("db.change", updateList);
    },
  };
}

async function updateList(event: CustomEvent<DbChangeMessage>): Promise<void> {
  if (event.detail.type !== "people") {
    return;
  }

  if (event.detail.action === "delete") {
    document
      .querySelector(`#people-completions option[data-person-id="${event.detail.id}"]`)
      ?.remove();
    return;
  }

  const row = await prayersdb.get("people", event.detail.id);
  if (!row) {
    console.warn("Unable to resolve record from new person event.", event.detail);
    return;
  }
  const existing = document.querySelector<HTMLOptionElement>(
    `#people-completions option[data-person-id="${event.detail.id}"]`,
  );

  if (existing) {
    existing.textContent = row.name;
    existing.value = row.name;
    return;
  }

  const completions = document.getElementById("people-completions");
  if (!completions) {
    return;
  }

  const opt = new Option(row.name);
  completions.append(opt);
}

async function checkForList(): Promise<void> {
  if (document.getElementById("people-completions")) {
    return;
  }

  if (!document.querySelector('input[list="people-completions"]')) {
    return;
  }

  const people = await prayersdb.getAll("people");
  people.sort((l, r) => l.name.localeCompare(r.name));

  const completions = el("datalist", { props: { id: "people-completions" } });
  for (const person of people) {
    const option = new Option(person.name);
    option.dataset["personId"] = person.id.toString();
    completions.append(option);
  }

  document.body.append(completions);
}
